import axios from 'axios';

export const SECRET_STORAGE_KEY = 'cp_admin_secret';

export const cloneProviderClient = axios.create({
  baseURL: process.env.REACT_APP_CLONE_PROVIDER_BASE_URL || '',
});

cloneProviderClient.interceptors.request.use((config) => {
  const secret = sessionStorage.getItem(SECRET_STORAGE_KEY);
  if (secret) config.headers.secret = secret;
  return config;
});

cloneProviderClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      sessionStorage.removeItem(SECRET_STORAGE_KEY);
      window.dispatchEvent(new Event('clone-provider-secret-invalid'));
    }
    return Promise.reject(error);
  }
);

export const unwrap = (response) => response.data?.data;
